import Http from "./base-http";

class UserBenefit extends Http {
  addUserBenefit(variables) {
    return this.create(variables);
  }
  delUserBenefit(id) {
    return this.destroy(id);
  }
}
const userBenefit = new UserBenefit({
  modelUrlPrefix : "UserBenefit"
});
export default userBenefit;
